import { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Navigate, useLocation } from 'react-router-dom';

import Cookies from '@comeon/tomcat-cookies';

import { generatePostAuthLocation } from '~/components/authentication';
import { setPostAuthLocation } from '~/components/authentication/ducks';
import { postAuthLocationSelector } from '~/components/authentication/ducks/selectors';
import {
	selectDefaultProduct,
	selectOneBankIDFlowEnabled,
	selectOneButtonFlow
} from '~/components/brand/ducks/selectors';
import { isSmallerSelector } from '~/components/layout/mediaquery';
import { ROUTE_LOGIN } from '~/components/router/constants';
import useContextualPathTransformer from '~/hooks/use-contextual-path-transformer';

import { PlayNow } from './async';

const PlaynowGateway = () => {
	const location = useLocation();
	const dispatch = useDispatch();
	const transformPath = useContextualPathTransformer();

	const postAuthLocation = useSelector(postAuthLocationSelector);
	const oneBankIDFlowEnabled = useSelector(selectOneBankIDFlowEnabled);
	const oneButtonFlow = useSelector(selectOneButtonFlow);
	const smaller = useSelector(isSmallerSelector);
	const defaultProduct = useSelector(selectDefaultProduct);

	useEffect(() => {
		if (oneBankIDFlowEnabled || oneButtonFlow) {
			const storedLocation = Cookies.getJSON('postAuthLocation');

			const authLocation =
				postAuthLocation ??
				storedLocation ??
				generatePostAuthLocation(location, smaller, defaultProduct, transformPath);

			dispatch(setPostAuthLocation(authLocation));

			if (storedLocation === authLocation) {
				Cookies.remove('postAuthLocation');
			}
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	if (!oneBankIDFlowEnabled && !oneButtonFlow) {
		return (
			<Navigate
				to={{
					pathname: ROUTE_LOGIN
				}}
				state={{
					from: location,
					implicit: true
				}}
			/>
		);
	}

	return <PlayNow />;
};

export default PlaynowGateway;
